<template>
    <div class="layout__container layout__padding-20-0">
        <div class="layout__width-80 layout__padding-clear">
            <el-steps class="" :active=stepCount align-center>
                <el-step icon="icon-step-circle text__size-24" title="Artwork Preview"></el-step>
                <el-step icon="icon-step-circle text__size-24" title="Select Print Options"></el-step>
                <el-step icon="icon-step-circle text__size-24"  title="Checkout"></el-step>
            </el-steps>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'stepguide',
        props: {
            stepCount: Number
        }
    }
</script>